'use client'
import { useTranslation } from '@/app/i18n/client'
import React from 'react'
import Image from 'next/image'
const EmptyResult = ({ searchTerm }: { searchTerm: string }) => {
  const { t } = useTranslation()
  return (
    <div className="w-[604px] ml-[27px] mobile-width mobile:ml-[0]">
      <h1 className="text-[32px] font-ns_bold mobile:text-center mobile:text-[24px]">
        {t('No Search Results found for')}{' '}
        <span className="text-[26px] me-1 text-secondary  ">
          {`"`}
          <span>
            {searchTerm}
            {`"`}
          </span>
        </span>
      </h1>
      <div className="flex flex-col justify-center items-center mt-[50px] mobile:mt-[20px]">
        <Image
          src="/assets/Icons/noImage/NoResult.svg"
          alt=""
          width={415}
          height={365}
        />
      </div>
      <p className="text-center text-[#666666] text-[16px]">
        {t('Check the spelling, try a more general term.')}
      </p>
      <div className="flex gap-[75.3px] ml-[30px] mt-[100px] mobile:ml-[0px] mobile:flex-col mobile:mt-[20px] mobile:gap-[20px]">
        <ul className="list-disc pl-4 text-[16px] text-[#666666]">
          <u className="font-ns_semibold">{t('Suggestions')}</u>
          <li className=" mt-[14.9px]">
            {t('Make sure that all words are spelled correctly')}.
          </li>
          <li>{t('Try different keywords')}.</li>
          <li>{t('Try more general keywords')}.</li>
          <li>{t('Try fewer keywords')}.</li>
        </ul>
        <div className="list-disc pl-4 text-[16px] text-[#666666]">
          <u>{t('Contact us')}</u>
          <div className="flex gap-[9.5px]  mt-[14.9px] mobile:mt-[0px] mobile:py-[5px]">
            <Image
              src="/assets/Icons/emailIcon.svg"
              alt=""
              width={16}
              height={11}
            />
            <p className="text-[14px] text-[#666666]">{t('Email Us')}</p>
          </div>
          <div className="flex gap-[9.5px]">
            <Image
              src="/assets/Icons/phoneIcon.svg"
              alt=""
              width={16}
              height={11}
            />
            <p className="text-[14px] text-[#666666]">
              {t('Call')} +33 4.90.89.33.00
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmptyResult
